import { useContext } from 'react'
import { ApiError } from '@/api/client'
import { said } from '@/domain/errors'
import { SessionCtx } from '@/hooks/useSession'

// 오류는 원인을 말하는 한 문장이다 — 문장은 domain/errors.ts 의 said 가 정한다.
// request_id 는 서버 로그를 찾는 열쇠라 로그를 읽을 수 있는 사람(최고 관리자·관리자)에게만 작게 붙는다.
// 사용자에게 그 값은 다음 행동을 정하는 데 쓰이지 않는다. 세션 밖(로그인·가입)도 사용자와 같다.
// `reasons` 는 같은 사유를 그 창의 조치로 말하는 문장이고, `codes` 는 사유 없는 코드를 그 창의 뜻으로 말하는 문장이다(`said`).

export function Err({
  error,
  reasons,
  codes,
}: {
  error: unknown
  reasons?: Readonly<Record<string, string>>
  codes?: Readonly<Partial<Record<ApiError['code'], string>>>
}) {
  const me = useContext(SessionCtx)
  if (!error) return null
  const e = error instanceof ApiError ? error : null
  const showId = me?.role === 'superadmin' || me?.role === 'admin'
  return (
    <div role="alert" className="rounded-lg border border-danger/35 bg-danger/8 px-3 py-2 text-[12px] text-danger-ink">
      {said(error, reasons, codes)}
      {showId && e?.requestId ? (
        <div className="mt-0.5 font-mono text-[11px] opacity-60">{e.requestId}</div>
      ) : null}
    </div>
  )
}
